module.exports = __webpack_public_path__ + "img/Jenkins.4e7c41e1.png";